'use strict';

angular.module('internal.trainings')
    .controller('InternalTrainingNote', ['$scope', '$stateParams', '$state', 'Notes',
        function ($scope, $stateParams, $state, Notes) {
        $scope.resetTraining();
        $scope.training_note = $stateParams.training_note;
        $scope.trainingNoteID = $stateParams.trainingNoteID;
        $scope.saving = false;
        $scope.deleting = false;
        $scope.loading = true;
        
        if ($stateParams.trainingNoteID != null) {
            Notes.getByID($stateParams.trainingNoteID).then(function (note) {
                $scope.training_note = note;
                $scope.loading = false;
            })
        }
        else {
            $scope.training_note = {};
            $scope.loading = false;
        }

        $scope.save = function () {
            $scope.saving = true;

            Notes.save($scope.training_note, $scope.trainingID).then(function (note) {
                updateArray($scope.training.notes, note);
                updateArray($scope.masterTraining.notes, note);
                $state.go('internal.licensing.training.notes', { id: $scope.trainingID });
                $scope.saving = false;
            });
        }

        $scope.delete = function () {
            $scope.deleting = true;

            Notes.delete($stateParams.trainingNoteID).then(function () {
                updateArray($scope.training.notes, $scope.training_note, true);
                updateArray($scope.masterTraining.notes, $scope.training_note, true);
                $scope.deleting = false;
                $state.go('internal.licensing.training.notes', { id: $scope.trainingID });
            })
        }

        $scope.toolbarGroups = [
		    { name: 'basicstyles' }
        ];
    }])
;